import { getSystemConfig } from '../system.config'
import { approvalNameSpace } from '../../config/config-name'

import { handleResponse, myAxios } from '../utils'
const { domain, gaiaKey } = getSystemConfig(approvalNameSpace)
const baseUrl = `${domain}` // baseUrl
const approvalGetDetail = `${baseUrl}/admin/push/pushInfo/v1/detailByInstanceId`
const pushGetail = `${baseUrl}/admin/inbox/task/v1/bpm-detail`

export const getApprovalDetail = async (params, token) => {
  return myAxios
    .post(approvalGetDetail, params, {
      headers: {
        'X-GAIA-API-KEY': gaiaKey,
        CASTGC: token
      },
      loading: false
    })
    .then(res => {
      return handleResponse(res, 'no-toast')
    })
}

export const getPushDetail = async (params, token) => {
  return myAxios
    .post(pushGetail, params, {
      headers: {
        'X-GAIA-API-KEY': gaiaKey,
        CASTGC: token
      },
      loading: false
    })
    .then(res => {
      return handleResponse(res, 'no-toast')
    })
}

export default {
  getApprovalDetail,
  getPushDetail
}
